@use "../styles.module.scss";
@use "../../../config/papers.module.scss";
@use "../../../config/defaults.module.scss" as defaults;

.layoutLogin {
  background: var(--bg-color-purple);
  background-size: cover;
  color: #000;

  display: flex;
  min-height: 100%;
	flex-direction: column;

  align-items: center;
  justify-content: center;
  padding: var(--gap);
}

.layoutLoginBF {
  background-color: #1e3a5f;
  color: #000;

  display: flex;
  min-height: 100%;

  align-items: center;
  justify-content: center;
  padding: var(--gap);
}

.whitePaper {
  @apply yst-rounded-md;
  @extend .whitePage;
  margin: auto;
  padding: 48px;

  @media screen and (max-width: defaults.$mediumBreakpoint) {
	width: 100%;
	max-width: 520px;
	padding: 24px;
  }

  @media screen and ( max-width: defaults.$mobileBreakpoint ) {
    width: 100%;
  }
}

